'use es6';

export const MODULE_VALIDATION_OCCURRENCE_DEFAULT_LESS_THAN_MIN = 'MODULE_VALIDATION_OCCURRENCE_DEFAULT_LESS_THAN_MIN';
export const MODULE_DATA_VALIDATION_LOCKED_REQUIRED_FIELD_MISSING = 'MODULE_DATA_VALIDATION_LOCKED_REQUIRED_FIELD_MISSING';
export const MODULE_DATA_VALIDATION_REQUIRED_FIELD_MISSING = 'MODULE_DATA_VALIDATION_REQUIRED_FIELD_MISSING';
export const MODULE_VALIDATION_CONTROLLING_VALUE_REGEX_NOT_SET = 'MODULE_VALIDATION_CONTROLLING_VALUE_REGEX_NOT_SET';